import { render, staticRenderFns } from "./SemiologiaOncologica.vue?vue&type=template&id=22a37269"
import script from "./SemiologiaOncologica.vue?vue&type=script&lang=js"
export * from "./SemiologiaOncologica.vue?vue&type=script&lang=js"
import style0 from "./SemiologiaOncologica.vue?vue&type=style&index=0&id=22a37269&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports